enum AnalyticsTypes {
  PAGE_VIEW = 'PAGE_VIEW',
  VIDEO_START = 'VIDEO_START',
  VIDEO_END = 'VIDEO_END',
  CTA_CLICK = 'CTA_CLICK'
}

export default AnalyticsTypes;
